import { useTranslation } from 'react-i18next';

export default function SafetySection() {
  const { t } = useTranslation();

  return (
    <section className="py-12 md:py-16 bg-white">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center gap-3 mb-4 md:mb-6">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-amber-50 text-amber-600">
              <i className="ri-alert-line text-lg" />
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-stone-800">
              {t('safety_h2')}
            </h2>
          </div>
          <p className="text-sm md:text-base text-stone-600 leading-relaxed mb-6">
            {t('safety_text')}
          </p>
          <a
            href="/cssbuy-safety/"
            className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium text-amber-700 bg-amber-50 rounded-lg hover:bg-amber-100 transition-colors"
          >
            {t('safety_cta')}
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}